import { REQUEST_GET_SUPPLIES_PRODUCTS_SUCCESS, REQUEST_GET_SUPPLIES_PRODUCTS_ERROR } from './supplies.actions';
import type { SuppliesProduct } from '../../pages/supplies-page/api/fetch-products';
import { emptyArray } from 'ui-components/default-props/empty';

type SuppliesState = {
  products: SuppliesProduct[];
  isLoading: boolean;
  hasLoaded: boolean;
  error: string | null;
};

type SuppliesActionWithPayload = {
  type: string;
  products?: SuppliesProduct[];
  error?: string;
};

const initialState: SuppliesState = {
  products: emptyArray as SuppliesProduct[],
  isLoading: true,
  hasLoaded: false,
  error: null,
};

const actionHandlerMap: Record<string, (state: SuppliesState, action: SuppliesActionWithPayload) => SuppliesState> = {
  [REQUEST_GET_SUPPLIES_PRODUCTS_SUCCESS]: (state: SuppliesState, action: SuppliesActionWithPayload) => ({
    ...state,
    products: action.products ?? (emptyArray as SuppliesProduct[]),
    isLoading: false,
    hasLoaded: true,
    error: null,
  }),
  [REQUEST_GET_SUPPLIES_PRODUCTS_ERROR]: (state: SuppliesState, action: SuppliesActionWithPayload) => ({
    ...state,
    isLoading: false,
    hasLoaded: true,
    error: action.error ?? null,
  }),
};

export const suppliesFromShopifyStore = (state = initialState, action: SuppliesActionWithPayload) => {
  const handler = actionHandlerMap[action.type];
  return handler ? handler(state, action) : state;
};
